import { Directive, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
  selector: '[appSlugify]'
})
export class SlugifyDirective implements OnInit{

  @Input() appSlugify: FormControl;
  @Output() onValueUpdated = new EventEmitter<string>();

  constructor(private el: ElementRef) { }

  @HostListener('input') onChange() {
    const finalValue = this.slugifyString(this.appSlugify.value);
    this.onValueUpdated.emit(finalValue)
  }

  ngOnInit(): void {
      
  }

  slugifyString(str) {
    var arabic = /[\u0600-\u06FF]/;
    if (str && arabic.test(str)) {
      return str
        .replace(/ /g, "-")
        .replace(/\'/g, "-")
        .replace(/'(\w)/g, "")
        .replaceAll(",", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("؟", "")
        .replaceAll("+", "")
        .replaceAll("=", "")
        .replaceAll(",", "")
        .replaceAll("!", "")
        .replace(/&/g,"and")

        .replace(/,/g, ""); // Remove all comma
    } else {
      const a =
        "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
      const b =
        "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------";
      const regex =
        "/[دجحخ هعغفقثصضذطكمنتالبيسشظزوةىلارؤءئإلإلأأ؟آلآ]|.|s/_,:;";
      const e =
        "/ [دجحخ هعغفقثصضذطكمنتالبيسشظزوةىلارؤءئإلإلأأ؟آلآ] |.|s /------";
      const p = new RegExp(a.split("").join("|"), "g");
      const s = new RegExp(regex.split("").join("|"), "g");
      if (str) {
        return str
          .toString()
          .toLowerCase()

          .replace(/\s+/g, "-") // Replace spaces with -
          .replace(/\'+/g,"-")
          .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
          .replace(s, (d) => e.charAt(regex.indexOf(d))) // Replace special characters
          .replace(/&/g, "-and-") // Replace & with 'and'
          .replace(/[^\w\-]+/g, "") // Remove all non-word characters
          .replace(/\-\-+/g, "-") // Replace multiple - with single -
          .replace(/^-+/, "") // Trim - from start of text
          .replace(/-+$/, "-") // Trim - from end of text;
          .replace(/,/g, "") // Remove all comma
          .replace(/ /g, "-")
          .replace(/'(\w)/gi, ""); // Remove all apostrophe S
      }
    }
  }

}

